'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _dropdownMenu = require('./dropdown-menu');

var _dropdownMenu2 = _interopRequireDefault(_dropdownMenu);

var _dropdownItem = require('../../src/styles/dropdown-item.scss');

var _dropdownItem2 = _interopRequireDefault(_dropdownItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropdownItem = function DropdownItem(props) {
	var item = props.item,
	    parent = props.parent,
	    isActive = props.isActive,
	    onItemClick = props.onItemClick,
	    toggleMobileSubmenu = props.toggleMobileSubmenu,
	    onItemMouseEnter = props.onItemMouseEnter,
	    ItemRenderer = props.ItemRenderer,
	    SectionHeaderRenderer = props.SectionHeaderRenderer,
	    itemDisplayNameTransform = props.itemDisplayNameTransform,
	    itemChildrenTransform = props.itemChildrenTransform,
	    isSectionHeaderTransform = props.isSectionHeaderTransform,
	    mobile = props.mobile,
	    itemOptions = props.itemOptions;

	var itemForRenderer = (0, _assign2.default)({}, itemOptions, item);
	if (isSectionHeaderTransform(item)) {
		return _react2.default.createElement(
			'li',
			{ key: item, className: '' + _dropdownItem2.default.listItem },
			_react2.default.createElement(SectionHeaderRenderer, { item: itemForRenderer, nameTransform: itemDisplayNameTransform })
		);
	}
	return _react2.default.createElement(
		'li',
		{ key: item, className: _dropdownItem2.default.listItem + ' ' + (isActive(item) ? _dropdownItem2.default.active : '') },
		!mobile && _react2.default.createElement(
			'div',
			{ className: _dropdownItem2.default.listItemLink + ' ' + _dropdownItem2.default.desktopItem,
				onClick: function onClick(event) {
					onItemClick(item, parent, event);
				},
				onMouseEnter: function onMouseEnter(event) {
					onItemMouseEnter(item, parent, event);
				} },
			_react2.default.createElement(ItemRenderer, { item: itemForRenderer, nameTransform: itemDisplayNameTransform, childrenTransform: itemChildrenTransform })
		),
		mobile && _react2.default.createElement(
			'div',
			{ className: _dropdownItem2.default.listItemLink + ' ' + _dropdownItem2.default.mobileItem,
				onClick: function onClick(event) {
					onItemClick(item, parent, event);
				} },
			_react2.default.createElement(ItemRenderer, { item: itemForRenderer, nameTransform: itemDisplayNameTransform, childrenTransform: itemChildrenTransform }),
			itemChildrenTransform(item) && _react2.default.createElement('div', { className: '' + _dropdownItem2.default.mobileTapArea,
				onClick: function onClick(event) {
					event.preventDefault();
					event.stopPropagation();
					toggleMobileSubmenu(item, parent, event);
				} })
		),
		itemChildrenTransform(item) && isActive(item) && _react2.default.createElement(_dropdownMenu2.default, {
			items: itemChildrenTransform(item),
			parent: item,
			isActive: isActive,
			onItemClick: onItemClick,
			toggleMobileSubmenu: toggleMobileSubmenu,
			onItemMouseEnter: onItemMouseEnter,
			ItemRenderer: ItemRenderer,
			SectionHeaderRenderer: SectionHeaderRenderer,
			itemDisplayNameTransform: itemDisplayNameTransform,
			itemChildrenTransform: itemChildrenTransform,
			isSectionHeaderTransform: isSectionHeaderTransform,
			mobile: mobile
		})
	);
};

DropdownItem.propTypes = {
	item: require('react').PropTypes.shape({
		id: require('react').PropTypes.any,
		name: require('react').PropTypes.string
	}).isRequired,
	parent: require('react').PropTypes.object,
	isActive: require('react').PropTypes.func,
	onItemClick: require('react').PropTypes.func,
	toggleMobileSubmenu: require('react').PropTypes.func,
	onItemMouseEnter: require('react').PropTypes.func,
	ItemRenderer: require('react').PropTypes.any,
	SectionHeaderRenderer: require('react').PropTypes.any,
	itemDisplayNameTransform: require('react').PropTypes.func,
	itemChildrenTransform: require('react').PropTypes.func,
	isSectionHeaderTransform: require('react').PropTypes.func,
	mobile: require('react').PropTypes.bool.isRequired
};
DropdownItem.displayName = 'DropdownItem';

DropdownItem.defaultProps = {
	onItemClick: function onItemClick() {},
	onItemMouseEnter: function onItemMouseEnter() {},
	onItemMouseLeave: function onItemMouseLeave() {},
	itemDisplayNameTransform: function itemDisplayNameTransform(item) {
		return item.name;
	},
	itemChildrenTransform: function itemChildrenTransform(item) {
		return item.children;
	}
};
exports.default = DropdownItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dropdown/lib/components/dropdown-item.js
// module id = 1463
// module chunks = 0